export function propertiesProxy<T>(instance) {
  return new Proxy(instance, {
    get(target, property, receiver) {
      return property as string;
    },
  });
}
